import React, { useRef } from 'react';
import { loadMicroApp } from 'qiankun';
import { useDidMount } from '../shared/hooks';

export default (props: any) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useDidMount(() => {
    loadMicroApp({
      ...props,
      container: containerRef.current!,
    });
  });

  return <div ref={containerRef} />;
};
